/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserData, selectAnnouncement } from '../../redux/selectors';
import './header.css';
import { FiMenu } from 'react-icons/fi';
import { FaHome, FaUser, FaFileAlt, FaGift, FaSlidersH, FaClipboardList, FaLock, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import Rules from './Rules';
import BonusRules from './BonusRules';
import SportsNavStrip from './SportsNavStrip';
import HeaderSearchBar from './HeaderSearchBar';
import Logo from '../../assets/img/logo.png';
import { IconButton, useDisclosure } from '@chakra-ui/react';
import { sendLogout } from '../../utils/webviewBridge';

const Header = ({ setIsSidebarOpen, hideSportsNav }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: bonusOpen, onOpen: openBonus, onClose: closeBonus } = useDisclosure();
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);
  const naviagte = useNavigate();
  const location = useLocation();
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();
  const announcement = useSelector(selectAnnouncement);
  const isCasinoPage = location.pathname === '/live-casino' || location.pathname.startsWith('/diamond-casino/play');

  const rawBalance = Number(userData?.balance || 0);
  const exposure = Math.abs(Number(userData?.liability || 0)).toFixed(2);
  const availableBalance = (rawBalance - Math.abs(Number(userData?.liability || 0))).toFixed(2);
  const balance = availableBalance;
  const bonus = '0.00';
  const available = availableBalance;
  const withdrawal = '0.00';

  const navigateTo = (path) => {
    naviagte(path);
    setProfileOpen(false);
  };

  const handleLogout = () => {
    sendLogout();
    dispatch({ type: 'gameData/logOut' });
    dispatch({ type: 'accountData/logOut' });
    localStorage.clear();
    window.location.href = '/';
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className='desktop-header-wrapper'>
      <Rules isOpen={isOpen} onClose={onClose} />
      <BonusRules isOpen={bonusOpen} onClose={closeBonus} />

      {/* Top Bar */}
      {/* <div className='header-top-bar'>
        <IconButton
          display={{ base: 'flex', md: 'none' }}
          onClick={() => setIsSidebarOpen((prev) => !prev)}
          variant='outline'
          aria-label='open menu'
          icon={<FiMenu color='#1a1a1a' />}
          size='sm'
          borderColor='rgba(255,255,255,0.3)'
          _hover={{ bg: 'rgba(255,255,255,0.1)' }}
        />

        <a href='/' className='header-top-bar__logo'>
          <img src={Logo} alt='IndoExch' />
        </a>

        <HeaderSearchBar className="header-search--desktop" />

        <button
          className='header-top-bar__rules-btn'
          onClick={onOpen}
          type='button'
        >
          RULES
        </button>

        <div className='header-top-bar__spacer' />

        {!isCasinoPage && (
          <div className='header-badges'>
            <div className='header-badge'>
              <span className='header-badge__ribbon'>BAL</span>
              <span className='header-badge__value'>{Math.floor(Number(userData?.balance || 0) - Math.abs(Number(userData?.liability || 0)))}</span>
            </div>
            <div className='header-badge header-badge--exp'>
              <span className='header-badge__ribbon'>EXP</span>
              <span className='header-badge__value'>{Math.floor(Math.abs(Number(userData?.liability || 0)))}</span>
            </div>
          </div>
        )}

        <div className='desktop-header__profile' ref={profileRef}>
          <a
            className='desktop-header__profile-trigger'
            onClick={() => setProfileOpen((prev) => !prev)}
          >
            <FaUser className='desktop-header__profile-icon' />
            <span className='desktop-header__profile-name'>
              {(userData?.username || '').toUpperCase()}
            </span>
            <span className={`desktop-header__caret ${profileOpen ? 'open' : ''}`}>&#9662;</span>
          </a>

          {profileOpen && (
            <div className='desktop-header__dropdown'>
              <div className='dropdown-banner'>
                HI, {(userData?.username || '').toUpperCase()}
              </div>

              <div className='dropdown-finance'>
                <div className='dropdown-finance__row'>
                  <span className='dropdown-finance__label'>Wallet Amount</span>
                  <span className='dropdown-finance__value'>{balance}</span>
                </div>
                <div className='dropdown-finance__row'>
                  <span className='dropdown-finance__label'>Net Exposure</span>
                  <span className='dropdown-finance__value dropdown-finance__value--red'>{exposure}</span>
                </div>
              
                <div className='dropdown-finance__row'>
                  <span className='dropdown-finance__label'>Withdrawal</span>
                  <span className='dropdown-finance__value'>{withdrawal}</span>
                </div>
              </div>

              <nav className='dropdown-menu-list'>
                <a className='dropdown-menu-item' onClick={() => navigateTo('/')}>
                  <FaHome className='dropdown-menu-item__icon' />
                  <span>Home</span>
                </a>
                <a className='dropdown-menu-item' onClick={() => navigateTo('/profile')}>
                  <FaUser className='dropdown-menu-item__icon' />
                  <span>My Profile</span>
                </a>
                <a className='dropdown-menu-item' onClick={() => navigateTo('/account')}>
                  <FaFileAlt className='dropdown-menu-item__icon' />
                  <span>Account Statement</span>
                </a>
                <a className='dropdown-menu-item' onClick={() => { setProfileOpen(false); openBonus(); }}>
                  <FaGift className='dropdown-menu-item__icon' />
                  <span>Bonus Rules</span>
                </a>
                <a className='dropdown-menu-item' onClick={() => navigateTo('/profile?tab=stake')}>
                  <FaSlidersH className='dropdown-menu-item__icon' />
                  <span>Stake Settings</span>
                </a>
                <a className='dropdown-menu-item' onClick={() => navigateTo('/report/unsetteled-bet')}>
                  <FaClipboardList className='dropdown-menu-item__icon' />
                  <span>Unsettled Bets</span>
                </a>
                <a className='dropdown-menu-item' onClick={() => navigateTo('/profile?tab=password')}>
                  <FaLock className='dropdown-menu-item__icon' />
                  <span>Change Password</span>
                </a>
              </nav>

              <button
                className='dropdown-signout-btn'
                type='button'
                onClick={handleLogout}
              >
                <FaSignOutAlt />
                SIGN OUT
              </button>
            </div>
          )}
        </div>
      </div> */}

      {/* Sports Navigation Strip */}
      {!hideSportsNav && <SportsNavStrip />}

    </div>
  );
};

export default Header;
